import uuid from 'react-native-uuid';
import { useQuery } from '@tanstack/react-query';
import { ApiLogger, getAdditionalProperties } from 'fmc-digital-common';
import { isEmpty } from 'lodash';
const useNTBBannerQuery = ({
  isNtbRequired,
  loanNumber
}) => {
  const selfServUrl = getAdditionalProperties('selfServUrl');
  const authToken = getAdditionalProperties('authToken');
  const xApiKey = getAdditionalProperties('xAPIKey');
  const correlationId = uuid.v4().toString();
  const config = {
    method: 'get',
    url: `${selfServUrl}/${loanNumber}/calc/ntb`,
    headers: {
      'Authorization': `Bearer ${authToken}`,
      'x-correlation-id': correlationId,
      'x-api-key': `${xApiKey}`
    }
  };
  return useQuery({
    queryKey: ['ntb', loanNumber],
    queryFn: () => ApiLogger(config),
    enabled: isNtbRequired && !isEmpty(loanNumber)
  });
};
export { useNTBBannerQuery };
//# sourceMappingURL=NTBBanner.js.map